import { prefixObjectValues as pre } from '../utils';

const prefix = 'board-certs-table';

const table = pre(
  {
    container: 'container',
    editBtn: 'edit-btn',
    deleteBtn: 'delete-btn',
    downloadBtn: 'download-btn',
    deleteMultipleBtn: 'delete-multiple-btn',
    exportCsvBtn: 'export-csv-btn',
    addBtn: 'add-btn',
    filterCheckbox: 'filter-checkbox',
    emptyState: 'empty-state',
  },
  prefix
);

export default {
  ...table,
};
